export default __webpack_public_path__ + "50a83d9.png";